import React from 'react';
import ClipsContext from '../ClipsContext';

export default function ClipsProvider(props) {
  const { children } = props;
  return <ClipsContext.Provider>{children}</ClipsContext.Provider>;
}
